<template>
  <div>
    <layout-loading v-if="isSubmit" />
    <BDataTable
      ref="refTable"
      :fetch-list="fetchArchive"
      :table-columns="tableColumns"
      @onGroupDelete="groupDelete"
    >
      <template #leftHeader="{ selectList }">
        <b-button
          v-if="selectList.length"
          variant="outline-danger"
          class="mr-1"
          :disabled="isSubmit"
          @click="groupDelete"
        >
          {{ $t("general.groupDelete") }} {{ selectList.length ? `(${selectList.length})` : "" }}
        </b-button>
        <b-button
          v-if="selectList.length"
          variant="outline-warning"
          class="mr-1"
          :disabled="isSubmit"
          @click="() => groupArchive(selectList, false)"
        >
          {{ $t("suggestions.unArchive") }} {{ $t("general.group") }} {{ selectList.length ? `(${selectList.length})` : "" }}
        </b-button>
      </template>
      <!-- Column: Archive -->
      <template #cell(archive)="{ item }">
        <b-form-checkbox
          :checked="item.archive"
          class="mt-1"
          switch
          inline
          @change="(val) => toggleArchive(item._id, val)"
        />
      </template>

      <!-- Column: Actions -->
      <template #cell(actions)="{ item }">
        <edit-row @click.native="toEditPage(item._id)" />
        <delete-row @click.native="deleteItem(item._id)" />
      </template>
    </BDataTable>
  </div>
</template>

<script>
import BDataTable from '@/components/BDataTable/index.vue'
import DeleteRow from '@/components/BDataTable/Actions/DeleteRow.vue'
import EditRow from '@/components/BDataTable/Actions/EditRow.vue'
import LayoutLoading from '@/components/LayoutLoading.vue'
import { BFormCheckbox, BButton } from 'bootstrap-vue'
import useSuggestionsList from './useSuggestionsList'

export default {
  name: 'SuggestionList',
  components: {
    BButton,
    BDataTable,
    BFormCheckbox,
    DeleteRow,
    EditRow,
    LayoutLoading,
  },
  setup() {
    const {
      deleteItem,
      fetchArchive,
      fetchList,
      groupArchive,
      groupDelete,
      isSubmit,
      refTable,
      tableColumns,
      toEditPage,
      toggleArchive,
    } = useSuggestionsList()

    return {
      deleteItem,
      fetchArchive,
      fetchList,
      groupArchive,
      groupDelete,
      isSubmit,
      refTable,
      tableColumns,
      toEditPage,
      toggleArchive,
    }
  },
}
</script>
